// Reference legend data for Correlation Finder, ported verbatim from the Backbone lib.
// Keyed `{secondary}-{primary}` where each part is the confidence level x1000.

export const LEGEND_COLUMNS = [
  ['Promoters', 'A'],
  ['Detractors', 'B'],
  ['Other', 'C']
]

export const LEGEND_ROWS = ['Females', 'Males']

// Flat triples per cell: [amount, percents, sigtest letters], column-major over LEGEND_ROWS,
// with the three column totals appended at the end.
export const LEGEND_VALUES = {
  '800-800': [
    215,
    0.5499,
    '',
    169,
    0.4322,
    'BC',
    228,
    0.7379,
    'A',
    81,
    0.2621,
    '',
    48,
    0.8,
    'A',
    12,
    0.2,
    '',
    391,
    309,
    60
  ],
  '800-850': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    170,
    0.6071,
    'A',
    67,
    0.2393,
    '',
    30,
    0.6522,
    'a',
    15,
    0.3261,
    '',
    391,
    280,
    46
  ],
  '850-850': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'BC',
    170,
    0.6071,
    'A',
    30,
    0.1071,
    '',
    28,
    0.7,
    'A',
    5,
    0.125,
    '',
    391,
    280,
    40
  ],
  '800-900': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    195,
    0.6964,
    'A',
    85,
    0.3036,
    '',
    35,
    0.6604,
    'a',
    18,
    0.3396,
    '',
    391,
    280,
    53
  ],
  '850-900': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    172,
    0.6143,
    'A',
    59,
    0.2107,
    '',
    28,
    0.6667,
    'a',
    13,
    0.3095,
    '',
    391,
    280,
    42
  ],
  '900-900': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'BC',
    211,
    0.701,
    'A',
    90,
    0.299,
    '',
    46,
    0.807,
    'A',
    11,
    0.193,
    '',
    391,
    301,
    57
  ],
  '800-950': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    215,
    0.7026,
    'A',
    91,
    0.2974,
    '',
    45,
    0.6618,
    'a',
    23,
    0.3382,
    '',
    391,
    306,
    68
  ],
  '850-950': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    176,
    0.6286,
    'A',
    51,
    0.1821,
    '',
    28,
    0.7,
    'a',
    11,
    0.275,
    '',
    391,
    280,
    40
  ],
  '900-950': [
    215,
    0.5499,
    '',
    174,
    0.445,
    'Bc',
    213,
    0.7607,
    'A',
    67,
    0.2393,
    '',
    41,
    0.6833,
    'a',
    19,
    0.3167,
    '',
    391,
    280,
    60
  ],
  '950-950': [
    215,
    0.5499,
    '',
    182,
    0.4655,
    'BC',
    205,
    0.6902,
    'A',
    92,
    0.3098,
    '',
    49,
    0.7,
    'A',
    21,
    0.3,
    '',
    391,
    297,
    70
  ],
  '800-980': [
    215,
    0.5499,
    '',
    188,
    0.4808,
    'Bc',
    214,
    0.7205,
    'A',
    83,
    0.2795,
    '',
    40,
    0.6557,
    'a',
    21,
    0.3443,
    '',
    391,
    297,
    61
  ],
  '850-980': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    180,
    0.6429,
    'A',
    45,
    0.1607,
    '',
    28,
    0.7,
    'a',
    10,
    0.25,
    '',
    391,
    280,
    40
  ],
  '900-980': [
    215,
    0.5499,
    '',
    172,
    0.4399,
    'Bc',
    213,
    0.7245,
    'A',
    81,
    0.2755,
    '',
    45,
    0.6716,
    'a',
    22,
    0.3284,
    '',
    391,
    294,
    67
  ],
  '950-980': [
    215,
    0.5499,
    '',
    177,
    0.4527,
    'Bc',
    201,
    0.7077,
    'A',
    83,
    0.2923,
    '',
    43,
    0.6935,
    'a',
    19,
    0.3065,
    '',
    391,
    284,
    62
  ],
  '980-980': [
    215,
    0.5499,
    '',
    169,
    0.4322,
    'BC',
    217,
    0.6955,
    'A',
    95,
    0.3045,
    '',
    49,
    0.7206,
    'A',
    19,
    0.2794,
    '',
    391,
    312,
    68
  ],
  '800-990': [
    215,
    0.5499,
    '',
    173,
    0.4425,
    'Bc',
    219,
    0.7228,
    'A',
    84,
    0.2772,
    '',
    48,
    0.7059,
    'a',
    20,
    0.2941,
    '',
    391,
    303,
    68
  ],
  '850-990': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    182,
    0.65,
    'A',
    39,
    0.1393,
    '',
    28,
    0.7,
    'a',
    9,
    0.225,
    '',
    391,
    280,
    40
  ],
  '900-990': [
    215,
    0.5499,
    '',
    169,
    0.4322,
    'Bc',
    197,
    0.7011,
    'A',
    84,
    0.2989,
    '',
    29,
    0.725,
    'a',
    11,
    0.275,
    '',
    391,
    281,
    40
  ],
  '950-990': [
    215,
    0.5499,
    '',
    172,
    0.4399,
    'Bc',
    203,
    0.657,
    'A',
    106,
    0.343,
    '',
    47,
    0.7015,
    'a',
    20,
    0.2985,
    '',
    391,
    309,
    67
  ],
  '980-990': [
    215,
    0.5499,
    '',
    175,
    0.4476,
    'Bc',
    212,
    0.7413,
    'A',
    74,
    0.2587,
    '',
    51,
    0.7083,
    'a',
    21,
    0.2917,
    '',
    391,
    286,
    72
  ],
  '990-990': [
    215,
    0.5499,
    '',
    191,
    0.4885,
    'BC',
    205,
    0.6949,
    'A',
    90,
    0.3051,
    '',
    55,
    0.7237,
    'A',
    21,
    0.2763,
    '',
    391,
    295,
    76
  ],
  '800-999': [
    215,
    0.5499,
    '',
    174,
    0.445,
    'Bc',
    210,
    0.6931,
    'A',
    93,
    0.3069,
    '',
    44,
    0.6769,
    'a',
    21,
    0.3231,
    '',
    391,
    303,
    65
  ],
  '850-999': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    190,
    0.6786,
    'A',
    30,
    0.1071,
    '',
    28,
    0.7,
    'a',
    7,
    0.175,
    '',
    391,
    280,
    40
  ],
  '900-999': [
    215,
    0.5499,
    '',
    176,
    0.4501,
    'Bc',
    214,
    0.7354,
    'A',
    77,
    0.2646,
    '',
    45,
    0.6618,
    'a',
    23,
    0.3382,
    '',
    391,
    291,
    68
  ],
  '950-999': [
    215,
    0.5499,
    '',
    170,
    0.4348,
    'Bc',
    205,
    0.7118,
    'A',
    83,
    0.2882,
    '',
    49,
    0.7,
    'a',
    21,
    0.3,
    '',
    391,
    288,
    70
  ],
  '980-999': [
    215,
    0.5499,
    '',
    165,
    0.422,
    'Bc',
    211,
    0.7057,
    'A',
    88,
    0.2943,
    '',
    54,
    0.7397,
    'a',
    19,
    0.2603,
    '',
    391,
    299,
    73
  ],
  '990-999': [
    215,
    0.5499,
    '',
    179,
    0.4578,
    'Bc',
    221,
    0.7083,
    'A',
    91,
    0.2917,
    '',
    53,
    0.7361,
    'a',
    19,
    0.2639,
    '',
    391,
    312,
    72
  ],
  '999-999': [
    215,
    0.5499,
    '',
    178,
    0.4552,
    'BC',
    227,
    0.7206,
    'A',
    88,
    0.2794,
    '',
    51,
    0.8226,
    'A',
    11,
    0.1774,
    '',
    391,
    315,
    62
  ]
}

export const LEGEND_NOTES = {
  '800-800': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>80%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>80%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" and cell "C" at <b>80%</b>']
  ],
  '800-850': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>85%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>80%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>85%</b> and cell "C" at <b>80%</b>']
  ],
  '850-850': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>85%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>85%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" and cell "C" at <b>85%</b>']
  ],
  '800-900': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>90%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>80%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>90%</b> and cell "C" at <b>80%</b>']
  ],
  '850-900': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>90%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>85%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>90%</b> and cell "C" at <b>85%</b>']
  ],
  '900-900': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>90%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>90%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" and cell "C" at <b>90%</b>']
  ],
  '800-950': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>95%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>80%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>95%</b> and cell "C" at <b>80%</b>']
  ],
  '850-950': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>95%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>85%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>95%</b> and cell "C" at <b>85%</b>']
  ],
  '900-950': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>95%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>90%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>95%</b> and cell "C" at <b>90%</b>']
  ],
  '950-950': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>95%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>95%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" and cell "C" at <b>95%</b>']
  ],
  '800-980': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>98%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>80%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>98%</b> and cell "C" at <b>80%</b>']
  ],
  '850-980': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>98%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>85%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>98%</b> and cell "C" at <b>85%</b>']
  ],
  '900-980': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>98%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>90%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>98%</b> and cell "C" at <b>90%</b>']
  ],
  '950-980': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>98%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>95%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>98%</b> and cell "C" at <b>95%</b>']
  ],
  '980-980': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>98%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>98%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" and cell "C" at <b>98%</b>']
  ],
  '800-990': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>80%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99%</b> and cell "C" at <b>80%</b>']
  ],
  '850-990': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>85%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99%</b> and cell "C" at <b>85%</b>']
  ],
  '900-990': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>90%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99%</b> and cell "C" at <b>90%</b>']
  ],
  '950-990': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>95%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99%</b> and cell "C" at <b>95%</b>']
  ],
  '980-990': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>98%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99%</b> and cell "C" at <b>98%</b>']
  ],
  '990-990': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>99%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" and cell "C" at <b>99%</b>']
  ],
  '800-999': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99.9%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>80%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99.9%</b> and cell "C" at <b>80%</b>']
  ],
  '850-999': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99.9%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>85%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99.9%</b> and cell "C" at <b>85%</b>']
  ],
  '900-999': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99.9%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>90%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99.9%</b> and cell "C" at <b>90%</b>']
  ],
  '950-999': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99.9%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>95%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99.9%</b> and cell "C" at <b>95%</b>']
  ],
  '980-999': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99.9%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>98%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99.9%</b> and cell "C" at <b>98%</b>']
  ],
  '990-999': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99.9%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>99%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" at <b>99.9%</b> and cell "C" at <b>99%</b>']
  ],
  '999-999': [
    [
      'Cell "B" is significantly greater than cell "A" at <b>99.9%</b>',
      'Cell "C" is significantly greater than cell "A" at <b>99.9%</b>'
    ],
    ['Cell "A" is significantly greater than cell "B" and cell "C" at <b>99.9%</b>']
  ]
}

// Rebuilds the sigtest example table for the active confidence pair. Mirrors the Backbone
// renderLegend assembly: walk rows x columns pulling each cell's triple out of the flat list.
export const buildLegendData = ({ confidenceLevel, significanceLevel }) => {
  const key = `${Math.round(1000 * significanceLevel)}-${Math.round(1000 * confidenceLevel)}`
  const values = LEGEND_VALUES[key]
  if (!values) return null

  const offset = values.length - LEGEND_COLUMNS.length
  const totals = [values[offset], values[offset + 1], values[offset + 2]]

  const data = LEGEND_ROWS.map((_row, i) =>
    LEGEND_COLUMNS.map((_col, j) => {
      const at = 3 * (j * LEGEND_ROWS.length + i)
      return [values[at], values[at + 1], values[at + 2]]
    })
  )

  return { totals, data, notes: LEGEND_NOTES[key] || [] }
}
